import { FincasPlataformaService } from "../../../shared/generated/grpc/plataforma_terceros_fincas_pb";
import { grpcCall, grpcClient } from "../../../shared/services/grpc/grpcCall";

/**
 * Baja de la RELACIÓN cliente-finca, no de la finca (`FincasPlataformaService.EliminarRelacion`, gRPC): la
 * finca sobrevive para sus otros dueños. Idempotente.
 */
export class FincaDeleteService {
  static readonly instance = new FincaDeleteService();
  private constructor() { }

  /** Da de baja la relación activa entre la finca y el cliente. */
  async delete(fincaId: string, clienteId: string): Promise<void> {
    await grpcCall(() => grpcClient(FincasPlataformaService).eliminarRelacion({ fincaId, clienteId }));
  }
}
